/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_End_LeadInputs */

const en_mk_tut_end_lead = /** @type {(inputs: Mk_Tut_End_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Free plan is enough to run this entire guide from start to finish without entering a card.`)
};

const id_mk_tut_end_lead = /** @type {(inputs: Mk_Tut_End_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Gratis cukup untuk menjalankan seluruh panduan ini dari awal sampai akhir tanpa memasukkan kartu.`)
};

/**
* | output |
* | --- |
* | "The Free plan is enough to run this entire guide from start to finish without entering a card." |
*
* @param {Mk_Tut_End_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_end_lead = /** @type {((inputs?: Mk_Tut_End_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_End_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_end_lead(inputs)
	return en_mk_tut_end_lead(inputs)
});